import angular from 'angular';
import ngRoute from 'angular-route';
import booksMenu from '../../menu/Menu';
import booksData from '../../data/BooksData';
import booksBankRecon from '../BankRecon/BankRecon';
/** Services */
import { BankReconHistoryService } from './services/BankReconHistoryService';
import { PrintStatementDialogService } from './services/PrintStatementDialog';
/** Routes */
import { statementListComponent } from './routes/main/statementList';
import { viewStatementComponent } from './routes/view/viewStatement';
import './bankReconHistory.css';

export default angular
  .module('bankReconHistory', [
    booksMenu,
    booksData,
    booksBankRecon,
    ngRoute,
    'ui.grid',
    'ui.grid.grouping'
  ])
  .controller('bankReconHistoryRoutesController', RouteController)
  .config(ConfigRoutes)
  .run(runInit)
  .service('BankReconHistoryService', BankReconHistoryService)
  .service('PrintStatementDialog', PrintStatementDialogService)
  .component('statementList', statementListComponent)
  .component('viewStatement', viewStatementComponent).name;

RouteController.$inject = [];

/*******************************************************************************
 * Config: ConfigRoutes */
/**
 * @ngdoc  config
 * @module bankReconHistory
 * @name   bankReconHistory.config:ConfigRoutes
 * @description
 * Sets up the route provider with the following routes.
 * /                The main screen when you first load the application.
 * /view/:id  {id}  This is the statement detail screen. Loads the statement for
 *                  the id.
 *******************************************************************************/
/* @ngInject */ function ConfigRoutes($routeProvider) {
  var resolveView = {
    data: function ($q, $route, BankReconHistoryService) {
      return BankReconHistoryService.get(Number($route.current.params.id)).then(
        function (resp) {
          if (!resp) return $q.reject();
          else return resp;
        }
      );
    }
  };

  $routeProvider
    .when('/', { template: '<statement-list></statement-list>' })
    .when('/view/:id', {
      resolve: resolveView,
      template:
        '<view-statement route-package="$resolve.data"></view-statement>'
    })
    .otherwise('/');
}

/*******************************************************************************
 * Run: runInit */
/**
 * @ngdoc  run
 * @module bankReconHistory
 * @name   bankReconHistory.run:runInit
 * @description
 * Setup the routes to redirect to the root if there are any errors during the
 * route change.
 *******************************************************************************/
/* @ngInject */ function runInit($rootScope, $location) {
  /*--------------------------------------*/
  /* Redirect to the root on route error. */
  /*--------------------------------------*/
  $rootScope.$on('$routeChangeError', function () {
    $location.url('/');
  });
}

/*******************************************************************************
 * Controller: RouteController */
/**
 * @ngdoc  controller
 * @module bankReconHistory
 * @name   bankReconHistory.controller:bankReconHistoryRoutesController
 * @description
 * Controller for the application. While this controller doesn't do anything
 * special directly, we still need a controller to be set as the books-controller
 * in the page.
 *******************************************************************************/
/* @ngInject */ function RouteController() {}
